import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Layout } from 'antd';

import FooterApp from './components/footer/footer';

import Header from './components/header/header';

import ContainerSignin from './containers/containerSignin';
import ContainerForgot from './containers/containerForgot';

import './App.css';

const { Content } = Layout;

class App extends Component {

  render() {
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <BrowserRouter basename="/mafume/erp/login">
          <Header />
          <Layout>
            <Content style={{ margin: '16px 16px' }} className="main-container-app">
              <Switch>
                <Route path="/forgot" component={ContainerForgot}/>
                <Route component={ContainerSignin}/>
              </Switch>
            </Content>
            <FooterApp></FooterApp>
          </Layout>
        </BrowserRouter>
      </Layout>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js